// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"012620bfad81a944","8310":"be0d22ab429259be","9389":"85fd4120a21b0b40"}[chunkId] + ".css";
};